<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HtmlToast',
  props:{
    html: String,
  }
})
</script>
<template>
  <div v-html="html">
  </div>
</template>
